import { useCallback } from "react";

type ImpactStyle = "light" | "medium" | "heavy" | "rigid" | "soft";
type NotificationType = "error" | "success" | "warning";

/**
 * Hook for Telegram Web App Haptic Feedback
 * Provides tactile feedback on user interactions
 */
export function useHaptic() {
  const webApp = window.Telegram?.WebApp;

  const impact = useCallback(
    (style: ImpactStyle = "medium") => {
      if (webApp?.HapticFeedback) {
        webApp.HapticFeedback.impactOccurred(style);
      }
    },
    [webApp]
  );

  const notification = useCallback(
    (type: NotificationType) => {
      if (webApp?.HapticFeedback) {
        webApp.HapticFeedback.notificationOccurred(type);
      }
    },
    [webApp]
  );

  const selectionChanged = useCallback(() => {
    if (webApp?.HapticFeedback) {
      webApp.HapticFeedback.selectionChanged();
    }
  }, [webApp]);

  // Convenience methods
  const tap = useCallback(() => impact("light"), [impact]);
  const success = useCallback(() => notification("success"), [notification]);
  const error = useCallback(() => notification("error"), [notification]);
  const warning = useCallback(() => notification("warning"), [notification]);

  return {
    impact,
    notification,
    selectionChanged,
    // Convenience
    tap,
    success,
    error,
    warning,
  };
}
